<template>
  <div>
    <v-container fluid class="text-center text-align">
      <v-row class="mt-12 pt-12" v-if="!items || !items.length">
        <v-col class="mt-12 pt-12">
          <div class="subtitle-1">
            <v-icon size="28" class="ml-2">mdi-signature-image</v-icon>
            no products...
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="(item, index) in elements"
          :key="index"
          class="d-flex child-flex"
          :cols="$store.state.display_grid[name]"
          v-show="products[item]"
        >
          <v-tooltip color="black" max-width="225" bottom>
            <template v-slot:activator="{ on }">
              <v-card flat outlined class="d-flex" v-on="on">
                <v-menu offset-x>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-if="products[item]"
                      v-on="on"
                      v-bind="attrs"
                      :src="
                        products[item].picture_url ||
                        products[item].thumbnail_url
                      "
                      :lazy-src="
                        products[item].picture_url ||
                        products[item].thumbnail_url
                      "
                      class="grey lighten-3"
                    >
                    </v-img>
                    <v-img
                      v-else
                      :src="'https://skotfashion.com/wp-content/uploads/2018/02/placeholder.jpg'"
                      :lazy-src="'https://skotfashion.com/wp-content/uploads/2018/02/placeholder.jpg'"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    />
                  </template>
                  <v-list subheader class="pb-0">
                    <v-list-item link>
                      <v-list-item-title
                        class="primary--text"
                        v-text="'Show product infos'"
                      ></v-list-item-title>
                    </v-list-item>
                    <v-list-item link>
                      <v-list-item-title
                        @click="select_item(item)"
                        class="primary--text"
                        v-text="'Add to sent list'"
                      ></v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card>
            </template>
            <v-row
              dense
              no-gutters
              justify="center"
              align="center"
              v-if="products[item]"
            >
              <v-col>
                <h5>{{ products[item].name }}</h5>
                <v-row dense>
                  <v-col cols="auto" class="text-truncate">
                    <h5>Price</h5>
                    <span>{{ products[item].price }}€</span>
                  </v-col>
                  <v-col
                    v-if="products[item].price_old"
                    cols="6"
                    class="text-truncate"
                  >
                    <h5>Old price</h5>
                    <strike> {{ products[item].price_old }}€ </strike>
                  </v-col>
                </v-row>
                <v-row v-if="comments && comments.length" dense no-gutters>
                  <v-col cols="12" sm="12">
                    <v-icon color="success" size="15">mdi-chevron-right</v-icon>
                    comments :
                  </v-col>
                  <v-col
                    v-for="(comment, i) in comments[index]"
                    :key="i"
                    cols="12"
                    sm="12"
                  >
                    <span class="pl-4"> - {{ comment.split(".")[1] }} </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <span v-else>-</span>
          </v-tooltip>
        </v-col>
        <v-col
          cols="12"
          class="mb-0 pb-0"
          v-if="items && items.length && elements.length !== items.length"
        >
          <v-btn small rounded color="#1a4dcd" dark @click="load_more">
            <strong>Load more</strong>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "products_slide",
  data: () => {
    return {
      elements: [],
      from: 0,
      to: 30,
      offset: 30,
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    ignored: {
      type: Array,
      default: () => [],
    },
    comments: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: () => null,
    },
  },
  mounted() {
    this.load_more();
  },
  computed: {
    products: {
      get: function () {
        const prod = this.$store.state.product.products;
        return prod;
      },
    },
  },
  methods: {
    load_more() {
      if (this.items && this.items.length) {
        for (
          let index = this.from;
          index < this.to && index < this.items.length;
          index++
        ) {
          this.elements.push(this.items[index]);
        }
        this.from = this.to;
        this.to += this.offset;
        // console.log(
        //   this.elements,
        //   this.from,
        //   this.to,
        //   this.elements.length,
        //   this.items.length
        // );
      }
    },
    select_item(item) {
      if (!this.$store.state.prod_to_sent.ids.includes(item)) {
        this.$store.state.prod_to_sent.ids.push(item);
        this.$store.state.prod_to_sent.item.push(this.products[item]);
        // console.log(this.$store.state.prod_to_sent);
      } else {
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: "This produts is already in sent list",
          color: "red",
          timeout: 900,
        });
      }
    },
    check_product_exist(item) {
      if (this.products[item]) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
